import { assert_number_gte_0, assert_string_not_empty, assert_type_boolean, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__database_entity } from '@shared/dto/_database_entity/DTO__database_entity';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { EWorkspaceSubscriptionTypePersonal } from '../workspace_subscription/EWorkspaceSubscriptionTypePersonal';
import { EWorkspaceSubscriptionTypeShared } from '../workspace_subscription/EWorkspaceSubscriptionTypeShared';

export class DTO__workspace extends DTO__database_entity {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE;

  static get_basic_info(target: DTO__workspace): DTO__workspace {
    let out = new DTO__workspace();

    out.is_basic_info_only = true;
    out._id = target._id;
    out.created_at = target.created_at;
    out.updated_at = target.updated_at;
    out.name = target.name;
    out.url_relative_avatar = target.url_relative_avatar;
    out.user_id_owner = target.user_id_owner;
    out.is_personal = target.is_personal;

    return out;
  }

  /*
   * INSTANCE FIELDS
   */
  is_basic_info_only!: boolean;

  user_id_owner!: string;

  name!: string;
  url_relative_avatar!: string;

  is_personal!: boolean;

  invite_by_link_enabled!: boolean;
  refresh_invite_link_after_usage!: boolean;

  credit_limit_for_new_workspace_users_enabled!: boolean;
  credit_limit_for_new_workspace_users!: number;

  permitted_features_for_new_workspace_users!: string[];

  activated_subscription!: string;

  notify_owner_about_reaching_credits_limit!: boolean;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.is_basic_info_only = false;
    this.permitted_features_for_new_workspace_users = [];
  }

  assert_standard_fields(): void {
    super.assert_standard_fields();

    assert_type_boolean(this.is_basic_info_only);

    assert_string_not_empty(this.user_id_owner);
    assert_string_not_empty(this.name);

    assert_type_boolean(this.is_personal);

    if (!this.is_basic_info_only) {
      assert_type_boolean(this.invite_by_link_enabled);
      assert_type_boolean(this.refresh_invite_link_after_usage);

      assert_type_boolean(this.credit_limit_for_new_workspace_users_enabled);
      assert_number_gte_0(this.credit_limit_for_new_workspace_users);

      assert_type_enum(this.activated_subscription, { ...EWorkspaceSubscriptionTypePersonal, ...EWorkspaceSubscriptionTypeShared });

      assert_type_boolean(this.notify_owner_about_reaching_credits_limit);
    }
  }
}
